<p-toast position="bottom-right" key="br" styleClass="crm-toast" />
<router-outlet></router-outlet>
<crm-drawer-host />
<crm-modal-host />
